module.exports = __webpack_public_path__ + "static/img/bayo_port_lg.983d9ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/bayonetta-microsite/bayo_port_lg.jpg
// module id = 226
// module chunks = 2